module.exports = __webpack_public_path__ + "media/images/IMG3_features-aeeef206.png";